import React from 'react';
import HeroSection from './HeroSection';
import PropertyTypes from './PropertyTypes';
import PopularDeals from './PopularDeals';
import AboutUs from './AboutUs';
import Counter from './Counter';
import Testimonial from './Testimonial';
import FeaturedProperties from './FeaturedProperties';
import Cta from './Cta';
import Footer from '../Layout/Footer';
import PropertyBookModal from './PropertyBookModal';

export default function Home() {
  return (
    <>
      <HeroSection/>
      <PropertyTypes/>
      <PopularDeals/>
      <AboutUs/>
      <Counter/>
      <Testimonial/>
      <FeaturedProperties/>
      <Cta/>
      <Footer/>
      <PropertyBookModal/>
    </>
  )
}
